module.exports = __webpack_public_path__ + "img/arrow-down_b.875e09ca.svg";